
import './bastidores.scss';
import { useEffect, useRef, useState } from 'react';
import { Pagination } from '@mui/material';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getAllBastidores, getMoreInfoVehicle } from '../shared/services/bastidores';
import MatriculaSearch from './components/MatriculaSearch';
import BastidoresTable from './components/BastidoresTable';
import InfoModal from '../shared/components/InfoModal';
import MoreInfoModal from './components/MoreInfoModal';

const Bastidores = () => {
    const dispatch = useDispatch();
    const containerRef = useRef();
    const [bastidores, setBastidores] = useState({
        total_pages: 0,
        results: [],
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [isOpenMoreInfo, setIsOpenMoreInfo] = useState(false);
    const [infoVehicle, setInfoVehicle] = useState(null);

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
        getBastidores(newPage);
    };

    const getBastidores = async (page = 1) => {
        dispatch({ type: 'loading/set', payload: true });
        try {
            const res = await getAllBastidores({ limit: 15, page });
            if (res.success) {
                containerRef.current.scrollIntoView({ behavior: 'smooth' });
                return setBastidores({
                    total_pages: res?.data?.totalPages ?? 0,
                    results: res?.data?.results ?? [],
                });
            }
            toast.error('No se ha podido obtener el listado de bastidores.');
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

    const getMoreInfo = async (ktype) => {
        dispatch({ type: 'loading/set', payload: true });
        try {
            const res = await getMoreInfoVehicle(ktype);
            if (res.success) {
                return setInfoVehicle(res.data);
            }
            toast.error('No se ha podido obtener más información del vehículo.');
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

    const openMoreInfo = async (ktype) => {
        await getMoreInfo(ktype);
        setIsOpenMoreInfo(true);
    };

    const closeMoreInfo = async (ktype) => {
        setIsOpenMoreInfo(false);
        setInfoVehicle(null);
    };

    useEffect(() => {
        getBastidores();
    }, []);

    return (
        <div className="bastidores content pt-3">
            <h1>Matrículas</h1>
            <div ref={containerRef}>
                <MatriculaSearch
                    setBastidores={setBastidores}
                    getBastidores={getBastidores}
                />
                <BastidoresTable
                    bastidores={bastidores}
                    openMoreInfo={openMoreInfo}
                />
                <div className="bastidores__pagination">
                    {bastidores.total_pages > 1 && (
                        <Pagination
                            className="mt-3 mb-2"
                            count={bastidores.total_pages}
                            page={currentPage}
                            onChange={handleChangePage}
                        />
                    )}
                </div>
            </div>
            {isOpenMoreInfo && (
                <InfoModal
                    state={isOpenMoreInfo}
                    title={'Información adicional del vehículo'}
                    content={<MoreInfoModal infoVehicle={infoVehicle} />}
                    width={'md'}
                    onClose={closeMoreInfo}
                ></InfoModal>
            )}
        </div>
    );
};

export default Bastidores;
